import { render, staticRenderFns } from "./hot-videos.vue?vue&type=template&id=d4bcc160&scoped=true&"
import script from "./hot-videos.vue?vue&type=script&lang=js&"
export * from "./hot-videos.vue?vue&type=script&lang=js&"
import style0 from "./hot-videos.vue?vue&type=style&index=0&id=d4bcc160&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bcc160",
  null
  
)

export default component.exports